import * as React from 'react';
import { FC } from 'react';

import { AlertBox } from './styled';
import { ISupportAlertBoxProps } from './types';

export const SupportAlertBox: FC<ISupportAlertBoxProps> = ({ children, alertStyle, testId }) => (
  <AlertBox data-testid={testId} alertStyle={alertStyle}>
    {children}
  </AlertBox>
);
